import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const AnnotationWrapper = styled.div`
  cursor: pointer;
  position: absolute;
  width: 0px;
  height: 0px;
  margin-left: 0px;
  /* left: ${props => props.procent}%; */
  left: ${props =>
    Math.round(props.procent).toFixed(1) > 90
      ? `calc(${Math.round(props.procent).toFixed(1)}% - 10px)`
      : `${Math.round(props.procent).toFixed(1)}%`};
  border-left: 5px solid ${props =>
    props.selected ? props.theme.colors.primary : props.theme.colors.xDarkgray};
  border-right: 5px solid ${props =>
    props.selected ? props.theme.colors.primary : props.theme.colors.xDarkgray};
  border-top: 26px solid ${props =>
    props.selected ? props.theme.colors.primary : props.theme.colors.xDarkgray};
  transition: border .2s ease-in-out;

  &:hover {
    border-left: 5px solid ${props => props.theme.colors.primary85};
    border-right: 5px solid ${props => props.theme.colors.primary85};
    border-top: 26px solid ${props => props.theme.colors.primary85};
  }

`;

class Annotation extends React.Component {
  onClick() {
    if (this.props.onClick) this.props.onClick();
  }

  render() {
    const { selected, procent } = this.props;
    return (
      <AnnotationWrapper
        selected={selected}
        procent={procent}
        onClick={() => this.onClick()}
      />
    );
  }
}

Annotation.propTypes = {
  selected: PropTypes.bool.isRequired,
  procent: PropTypes.number.isRequired,
  onClick: PropTypes.func
};

export default Annotation;



// WEBPACK FOOTER //
// ./src/components/VideoPlayer/Annotation.js